import { render } from "./HelpText.vue?vue&type=template&id=49863f24&scoped=true&bindings={\"helpTextKey\":\"props\",\"title\":\"props\",\"close\":\"options\"}"
import script from "./HelpText.vue?vue&type=script&lang=js"
export * from "./HelpText.vue?vue&type=script&lang=js"

import "./HelpText.vue?vue&type=style&index=0&id=49863f24&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-49863f24"

export default script